// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cancellation .pending-block[data-v-174babfe]{align-items:center;background:color-mix(in srgb,var(--white),transparent 30%);display:flex;height:100%;justify-content:center;position:absolute;top:0;width:100%;z-index:100}#cancellation .pending-block p[data-v-174babfe]{margin-bottom:0;margin-left:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
